import "@/App.css";
import { useSmoothScroll } from "@/hooks/useSmoothScroll";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Partners from "@/components/landing/Partners";
import Stats from "@/components/landing/Stats";
import RoofDivider from "@/components/landing/RoofDivider";
import LineDivider from "@/components/landing/LineDivider";
import ScrollProgress from "@/components/landing/ScrollProgress";
import BackToTop from "@/components/landing/BackToTop";
import Problems from "@/components/landing/Problems";
import Services from "@/components/landing/Services";
import NoDemolition from "@/components/landing/NoDemolition";
import WhyUs from "@/components/landing/WhyUs";
import About from "@/components/landing/About";
import Process from "@/components/landing/Process";
import References from "@/components/landing/References";
import ServiceArea from "@/components/landing/ServiceArea";
import Calculator from "@/components/landing/Calculator";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import MobileBar from "@/components/landing/MobileBar";

function App() {
  useSmoothScroll();

  return (
    <div className="relative min-h-screen bg-white antialiased">
      <ScrollProgress />
      <Header />
      <main className="pb-14 lg:pb-0">
        <Hero />
        <LineDivider />
        <Calculator />
        <Problems />
        <RoofDivider from="#ffffff" to="#0E5A75" />
        <Stats />
        <RoofDivider from="#0E5A75" to="#f8fafc" />
        <Services />
        <NoDemolition />
        <WhyUs />
        <Partners />
        <About />
        <Process />
        <References />
        <ServiceArea />
        <Calculator id="ajanlatkeres-2" />
        <Contact />
        <RoofDivider from="#ffffff" to="#08313F" />
      </main>
      <Footer />
      <MobileBar />
      <BackToTop />
    </div>
  );
}

export default App;
